import { BUILD_EVENT, TComponent } from '@core';
import * as apis from '@core/apis';
import { EEVents } from '@core/constants';
import * as Events from '@core/events';
import Field from '@core/managers/Field';
import { TSchemaValidation } from '@core/types';

enum RULES {
  AND = 'and',
  OR = 'or',
}

const ruleMapper = {
  [RULES.OR]: (field: Field, validations: TSchemaValidation): boolean =>
    field.fieldHasError(apis.validations.run(field.value, validations)),
  [RULES.AND]: (field: Field, validations: TSchemaValidation): boolean => {
    const errors = [];

    for (const validation in validations) {
      errors.push(
        field.fieldHasError(
          apis.validations.run(field.value, {
            [validation]: validations[validation],
          }),
        ),
      );
    }

    return errors.every((val) => val);
  },
};

const handleVisibility = (field: Field, visibility: boolean) => {
  field.visibility = visibility;
  field.rehydrate();

  if (!field.visibility)
    field.errors = {};
}

export const handler = ({
  form,
  field,
  eventReducedSchema,
}: Pick<Events.TEventInformation<unknown>, 'form' | 'field' | 'eventReducedSchema'>) => {
  eventReducedSchema.visibilityConditions?.forEach(
    ({ validations, fieldName, fieldNames, rule, showOnlyIfTrue }) => {
      const fields = [...(fieldNames || [fieldName])];
      const mapper = rule || 'or';

      fields.forEach((targetFieldName) => {
        if (!targetFieldName) return;

        const hasError = ruleMapper[mapper](field, validations);
        const visibility = showOnlyIfTrue
          ? ruleMapper[mapper](field, validations) === true
          : !hasError;
        // IF ITS NOT INITIALIZED, SUBSCRIBE TO ITS MOUNT
        if (!form.fields[targetFieldName]) {
          field.subscribe(
            BUILD_EVENT(EEVents.ON_FIELD_MOUNT, targetFieldName),
            () => handleVisibility(form.fields[targetFieldName], visibility),
          );
          return;
        }

        handleVisibility(form.fields[targetFieldName], visibility);
      });
    },
  );
};

export const events = (component: TComponent) =>
  Object.keys(component.visibilityConditions || {});
